<template>
  <div class="directory-wrapper" :class="{ 'directory-wrapper--basic': uiType === 'basic' }">
    <header class="directory-header" v-if="uiType === 'advanced'">
      <div class="directory-header__inner">
        <h1 class="directory-header__title"><em>{{ directoryTitle }}</em> Directory</h1>

        <DirectorySort :sort="sort" v-if="isGrid"/>
        <DirectorySearch :assets="assets" :searchTerm="searchTerm"/>

        <div class="directory-header__actions" v-if="canToggleView">
          <button
            :class="{ 'is-active': isList }"
            type="button"
            aria-label="List View"
            v-html="assets.list"
            @click="setView('list')"
          />

          <button
            :class="{ 'is-active': isGrid }"
            type="button"
            aria-label="Grid View"
            v-html="assets.grid"
            @click="setView('grid')"
          />
        </div>
      </div>

      <div v-if="searchTerm" class="directory-header__summary">
        <strong>Searching: </strong> {{ searchTerm }}
        (<button type="button" @click="setSearch(null)">Reset</button>)
      </div>
    </header>

    <header class="directory-header" v-if="uiType === 'basic'">
      <div class="directory-header__inner">
        <h3 class="directory-header__title">{{ basicTitle }}</h3>

        <div class="directory-header__actions" v-if="canToggleView">
          <button
            :class="{ 'is-active': isList }"
            type="button"
            aria-label="List View"
            v-html="assets.list"
            @click="setView('list')"
          />

          <button
            :class="{ 'is-active': isGrid }"
            type="button"
            aria-label="Grid View"
            v-html="assets.grid"
            @click="setView('grid')"
          />
        </div>
      </div>
    </header>

    <div v-if="!items.length" class="directory-empty">
      No results found.
    </div>

    <DirectoryLetterToggle v-if="showLetterToggle" :letterView="letterView" :letters="employeeNavLetters"/>

    <a v-if="callToAction" class="cta btn btn--fill" title="Join a Club or Organization" href="directory/joinclubs">{{ callToAction }}</a>

    <DirectoryTable
      :type="type"
      :items="items"
      :assets="assets"
      :sort="sort"
      v-if="isList"
    />

    <DirectoryGrid
      :type="type"
      :items="items"
      :assets="assets"
      v-if="isGrid"
    />
  </div>
</template>

<script>
import DirectoryGrid from './components/DirectoryGrid'
import DirectoryTable from './components/DirectoryTable'
import DirectorySearch from './components/DirectorySearch'
import DirectorySort from './components/DirectorySort'
import DirectoryLetterToggle from './components/DirectoryLetterToggle'

export default {
  name: 'Directory',

  components: {
    DirectoryGrid,
    DirectoryTable,
    DirectorySearch,
    DirectorySort,
    DirectoryLetterToggle
  },

  data() {
    return {
      type: null,
      originalItems: [],
      items: [],
      assets: [],
      view: 'grid',
      canToggleView: window.matchMedia('(min-width: 768px)').matches,
      searchTerm: null,
      uiType: 'advanced',
      basicTitle: null,
      employeeNavLetters: [],
      letterView: null,
      sort: ['name', 'asc']
    }
  },

  computed: {
    directoryTitle() {
      if (this.type === 'alloffices') {
        return 'Offices';
      }

      if (this.type === 'facultystaff') {
        return 'Faculty & Staff';
      }

      if (this.type === 'clubsorgs') {
        return 'Clubs & Orgs';
      }
    },

    isList() {
      return this.view === 'list'
    },

    isGrid() {
      return this.view === 'grid'
    },

    showLetterToggle() {
      return (this.type === 'facultystaff' && this.uiType === 'advanced') && !this.searchTerm
    },

    callToAction() {
      if (this.type === 'clubsorgs') {
        return 'Join a Club or Organization';
      }
    }
  },

  watch: {
    sort: function ([field, dir]) {
      let items = this.originalItems.slice()

      if (this.letterView) {
        items = items.filter(i => i.name.toUpperCase()[0] === this.letterView)
      }

      items = items.sort((a, b) => {
        const aField = a[field] || ''
        const bField = b[field] || ''

        return aField.localeCompare(bField)
      })

      if (dir === 'desc') {
        items.reverse()
      }

      this.items = items
    },

    letterView: function (letter) {
      let items = this.originalItems.slice().filter(i => i.name.toUpperCase()[0] === this.letterView)

      if (this.sort[1] === 'desc') {
        items = items.reverse()
      }

      this.items = items
    }
  },

  methods: {
    setView(view) {
      this.view = view
    },

    setSort(newSort) {
      this.sort = newSort
    },

    setSearch(term) {
      this.searchTerm = term

      if (term) {
        this.items = this.originalItems.filter(i => i.name && i.name.toLowerCase().includes(term.toLowerCase()))
      } else {
        this.items = this.originalItems
      }
    },

    setLetterView(letter) {
      this.letterView = letter
    }
  },

  created() {
    const initialData = JSON.parse(document.getElementById('directory-data').textContent)

    this.type = initialData.type
    this.items = initialData.items
    this.originalItems = initialData.items
    this.assets = initialData.assets
    this.uiType = initialData.uiType
    this.basicTitle = initialData.title || null
    this.employeeNavLetters = initialData.employeeNavLetters || []

    if (this.showLetterToggle) {
      this.letterView = 'A'
    }

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        this.canToggleView = true
      } else {
        this.canToggleView = false
        this.view = 'grid'
      }
    })
  }
}
</script>
